<template>
  <div>
    <PageAllow controller="PurchaseUserTasks" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card class="my-5">
          <v-card-title>
            {{ $t("PurchaseTaskSetting.purchase_tasks.name") }}
            <v-spacer></v-spacer>
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'PurchaseUserTasks',
                  'materialImport'
                )
              "
              small
              color="print"
              dark
              @click.stop="ImportDialog = true"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-import</v-icon>
              {{ $t("PurchaseTaskSetting.purchase_tasks.material_import") }}
            </v-btn>
            <v-btn
              small
              color="primary"
              class="ms-1"
              @click.stop="
                Add = true;
                currentTaskItem = {};
              "
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("PurchaseTaskSetting.purchase_tasks.newTask") }}
            </v-btn>
          </v-card-title>
          <v-divider />
          <div class="mx-4 mb-4">
            <v-data-table
              item-key="id"
              :headers="taskHeaders"
              :items="purchaseUserTasks"
              :loading="loading"
              multi-sort
              :search="filter"
              :expanded.sync="expanded"
              show-expand
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        purchase_user_tasks
                          ? [
                              1,
                              purchase_user_tasks.length,
                              purchase_user_tasks.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-spacer />
                  <v-row no-gutters class="me-n3">
                    <v-spacer />
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="filter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:header.data-table-expand="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>
              <template v-slot:expanded-item="{ item }">
                <td colspan="2" class="theme--light">
                  <v-card-text class="mt-8 pb-12 theme--light">
                    <v-row align="center">
                      <!-- 商品 -->
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("PurchaseTaskSetting.purchase_tasks.materials") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn
                          color="primary"
                          outlined
                          @click="
                            materials_dialog = true;
                            currentItem = JSON.parse(JSON.stringify(item));
                          "
                          >{{
                            $t("CRUD.chooseInfo", [
                              $t(
                                "PurchaseTaskSetting.purchase_tasks.materials"
                              ),
                            ])
                          }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-data-table
                          :headers="materialHeaders"
                          :items="item.purchase_user_categories"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-1"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:item.Description="{ item }">
                            <span>
                              {{
                                $t(settings
                                    ? settings.material_name_display_type == 1
                                        ? "Material.materialName"
                                        : settings.material_name_display_type == 4
                                            ? "Material.nameWithCode"
                                        : "Material.materialNameWithCode"
                                    : "Material.materialName", [item.material_code, item.material_name])
                              }}
                            </span>
                            <br />
                            <span class="caption secondary--text">
                              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                                {{ item.standard_name.slice(0, 12) + "......" }}
                              </span>
                              <span v-else>
                                {{ item.standard_name }}
                              </span>
                            </span>
                          </template>
                          <!-- 删除操作 -->
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="del(item)"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("PurchaseTaskSetting.purchase_tasks.staff") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn
                          color="primary"
                          outlined
                          @click="
                            user_dialog = true;
                            currentItem = JSON.parse(JSON.stringify(item));
                          "
                          >{{ $t("PurchaseTaskSetting.purchase_tasks.choose") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-data-table
                          :headers="roleHeaders"
                          :items="item.account_user ? [item.account_user] : []"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-1"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <!-- 删除操作 -->
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="delUser(item)"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </td>
              </template>
              <template v-slot:item.name="{ item }">
                {{ item.name
                }}<v-icon
                  x-small
                  color="primary"
                  class="px-1 py-4 me-1"
                  @click.stop="
                    Add = true;
                    currentTaskItem = { id: item.id, name: item.name };
                  "
                  >fa-pencil-alt
                </v-icon>
              </template>
            </v-data-table>
          </div>
          <!-- </v-card-text> -->
        </v-card>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="success" block @click="save()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    <!-- 新增、编辑任务 -->
    <v-dialog v-model="Add" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("PurchaseTaskSetting.purchase_tasks.info") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Add = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 subtitle-1">
          <ValidationObserver ref="taskObserver">
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("PurchaseTaskSetting.purchase_tasks.taskName")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('PurchaseTaskSetting.purchase_tasks.taskName')"
                >
                  <v-text-field
                    v-model="currentTaskItem.name"
                    dense
                    :error-messages="errors"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="Add = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="SubmitTask()">
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MaterialsSelectsDialog
      v-model="materials_dialog"
      :materialIds="
        currentItem
          ? currentItem.purchase_user_categories
            ? currentItem.purchase_user_categories.map((m) => m.id)
            : []
          : []
      "
      @confirm="choosedMaterials = $event"
    />
    <DialogAccountUser
      v-model="user_dialog"
      :userChoosed="
        currentItem && currentItem.account_user
          ? [currentItem.account_user]
          : []
      "
      @confirm="addUser = $event"
      :usersIdDisabled="userDisabledArr"
    />
    <ImportExcelAlert
      v-model="ImportDialog"
      @import="
        excelFile = $event;
        importExcel();
      "
      downloadFromAPI
      @download="Export()"
    />
    <ImportTasksResult
      v-model="importTasksResultFlg"
      :items="importTasksResult"
      v-on:close="
        importTasksResultFlg = false;
        getPurchaseUserTasksSettingFromAPI();
      "
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import PurchaseUserTasks from "@/api/purchase_user_tasks";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MaterialsSelectsDialog from "./plugins/MaterialsSelectsDialog";
import DialogAccountUser from "./plugins/DialogAccountUser";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import ImportTasksResult from "./plugins/ImportTasksResult";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
    MaterialsSelectsDialog,
    DialogAccountUser,
    ImportExcelAlert,
    ImportTasksResult,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("PurchaseTaskSetting.objectName"),
        disabled: true,
        href: "",
      },
    ],
    roleHeaders: () => [
      {
        text: i18n.t("PurchaseTaskSetting.purchase_tasks.staff_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("PurchaseTaskSetting.purchase_tasks.del"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    taskHeaders: () => [
      {
        text: i18n.t("PurchaseTaskSetting.purchase_tasks.tasks"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("PurchaseTaskSetting.purchase_tasks.actions"),
        align: "start",
        sortable: false,
        value: "data-table-expand",
        width: "120px",
      },
    ],
    materialHeaders: () => [
      {
        text: i18n.t("PurchaseTaskSetting.purchase_tasks.categories"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("PurchaseTaskSetting.purchase_tasks.material_name"),
        align: "start",
        sortable: false,
        value: "Description",
      },
      {
        text: i18n.t("PurchaseTaskSetting.purchase_tasks.del"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    purchaseUserTasks() {
      var tasks = [];
      if (this.purchase_user_tasks && this.purchase_user_tasks.length) {
        tasks = this.purchase_user_tasks.map((task) => {
          // 商品分类获取任务id
          task.purchase_user_categories.forEach((category) => {
            category.task_id = task.id;
          });
          // 员工获取任务id
          if (task.account_user) {
            task.account_user.task_id = task.id;
            // Object.assign({}, task.account_user, { task_id: task.id });
          }
          return task;
        });
      }
      return tasks;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    purchase_user_tasks: [],
    expanded: [],
    Add: false,
    currentTaskItem: {},
    filter: "",
    materials_dialog: false,
    materialIds: [],
    materials: [],
    choosedMaterials: [],
    currentItem: null,
    addUser: null,
    user_dialog: false,
    userDisabledArr: [],
    categoriesDisabledArr: [],
    ImportDialog: false,
    excelFile: null,
    importTasksResultFlg: false,
    importTasksResult: [],
  }),

  mounted() {
    this.getPurchaseUserTasksSettingFromAPI();
  },

  methods: {
    getPurchaseUserTasksSettingFromAPI() {
      PurchaseUserTasks.fetch(this.$route.query.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase_user_tasks = response.data.purchase_user_task;
            this.purchase_user_tasks.forEach((task) => {
              if (task.purchase_user_categories) {
                task.purchase_user_categories.forEach((category, index) => {
                  let Description = i18n.t(
                    this.settings
                      ? this.settings.material_name_display_type == 4
                        ? "Material.nameWithCodeAndStandard"
                        : this.settings.material_name_display_type == 3
                        ? "Material.materialNameWithCodeAndStandard"
                        : this.settings.material_name_display_type == 2
                        ? "Material.materialNameWithCode"
                        : "Material.materialName"
                      : "Material.materialName",
                    [
                      category.material_code,
                      category.material_name,
                      category.standard_name,
                    ]
                  );
                  task.purchase_user_categories[index].Description =
                    Description;
                  task.purchase_user_categories[index].detail_id = category.id;
                  task.purchase_user_categories[index].name =
                    category.category_name;
                  task.purchase_user_categories[index].code =
                    category.category_code;
                  task.purchase_user_categories[index].id =
                    category.material_id;
                });
              }
            });
          }
        }.bind(this)
      );
    },
    save() {
      this.$store.dispatch("fullscreenLoading");
      let postData = [];
      for (let i = 0; i < this.purchase_user_tasks.length; i++) {
        let data = {
          id: this.purchase_user_tasks[i].id,
          account_user_id: this.purchase_user_tasks[i].account_user_id,
          purchase_user_categories: [],
        };
        if (this.purchase_user_tasks[i].purchase_user_categories) {
          this.purchase_user_tasks[i].purchase_user_categories.forEach(
            (material) => {
              data.purchase_user_categories.push({
                material_id: material.id,
              });
            }
          );
        }
        postData.push(data);
      }
      PurchaseUserTasks.saveTaskCategories(postData)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.getPurchaseUserTasksSettingFromAPI();
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    // 新建、编辑任务
    SubmitTask() {
      this.$refs.taskObserver.validate().then(
        function (result) {
          if (result) {
            if (this.currentTaskItem.id) {
              PurchaseUserTasks.edit({
                id: this.currentTaskItem.id,
                account_user_id: this.currentTaskItem.account_user_id,
                name: this.currentTaskItem.name,
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.Add = false;
                    this.getPurchaseUserTasksSettingFromAPI();
                  }
                }.bind(this)
              );
            } else {
              PurchaseUserTasks.add({
                stock_id: this.$route.query.stock_id,
                account_user_id: this.currentTaskItem.account_user_id,
                name: this.currentTaskItem.name,
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.Add = false;
                    this.getPurchaseUserTasksSettingFromAPI();
                  }
                }.bind(this)
              );
            }
          }
        }.bind(this)
      );
    },
    del(data) {
      // 删除分类
      this.purchase_user_tasks.forEach((task) => {
        if (task.id == data.task_id) {
          task.purchase_user_categories.forEach((category, index) => {
            if (category.id == data.id) {
              task.purchase_user_categories.splice(index, 1);
            }
          });
        }
      });
    },
    delUser(data) {
      // 删除员工
      this.purchase_user_tasks = this.purchase_user_tasks.map((task) => {
        if (task.id == data.task_id) {
          task = Object.assign({}, task, {
            account_user: null,
            account_user_id: null,
          });
        }
        return task;
      });
      this.addUser = null;
      this.currentItem = null;
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      PurchaseUserTasks.Import(this.$route.query.stock_id, this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.ImportDialog = false;
                this.importTasksResultFlg = true;
                this.importTasksResult = response.data.data;
              } else {
                this.$snackbar.info(i18n.t("DistributionUser.import.success"));
                this.ImportDialog = false;
                this.getPurchaseUserTasksSettingFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    Export() {
      PurchaseUserTasks.Export({ stock_id: this.$route.query.stock_id });
    },
  },

  watch: {
    Add: {
      handler() {
        if (!this.Add) {
          this.$refs.taskObserver.reset();
        }
      },
    },
    choosedMaterials: {
      handler() {
        if (this.choosedMaterials.length) {
          this.choosedMaterials.forEach((material) => {
            material.category_name = material.material_category.name;
            material.material_id = material.id;
            this.currentItem.purchase_user_categories.push(material);
          });
          var index = this.purchase_user_tasks.findIndex(
            (task) => task.id == this.currentItem.id
          );
          this.purchase_user_tasks.splice(index, 1, this.currentItem);
        }
      },
    },
    addUser: {
      handler() {
        if (this.addUser) {
          var index = this.purchase_user_tasks.findIndex(
            (task) => task.id == this.currentItem.id
          );
          this.currentItem.account_user = this.addUser;
          this.purchase_user_tasks.splice(index, 1, this.currentItem);
          this.purchase_user_tasks[index].account_user_id = this.addUser.id;
        }
      },
    },
    //  分拣任务员工
    user_dialog: {
      handler() {
        if (this.user_dialog) {
          var ids = [];
          if (this.currentItem) {
            this.purchase_user_tasks.forEach((d) => {
              if (d.account_user) {
                if (this.currentItem.account_user) {
                  if (d.account_user.id != this.currentItem.account_user.id) {
                    ids.push(d.account_user.id);
                  }
                } else {
                  ids.push(d.account_user.id);
                }
              }
            });
          }
          this.userDisabledArr = ids;
        }
      },
    },
    materials_dialog: {
      handler() {
        if (this.materials_dialog) {
          let categoriesids = [];
          if (this.currentItem) {
            this.purchase_user_tasks.forEach((d) => {
              // 商品不重复
              if (d.purchase_user_categories.length) {
                d.purchase_user_categories.map((c) => {
                  categoriesids.push(c.material_id);
                });
              }
            });
          }
          this.categoriesDisabledArr = categoriesids;
        }
      },
    },
    ImportDialog: {
      handler() {
        if (!this.ImportDialog && this.excelFile) {
          this.excelFile = null;
        }
      },
    },
  },
};
</script>